import styled from "styled-components";

export const Wrapper = styled.div`
  background: url("https://res.cloudinary.com/dfpnxd8gj/image/upload/v1659036574/zqkniaylf4kdwxsjxlqv.jpg")
    no-repeat center fixed;
  background-size: cover;
`;
